import { Switch } from '@components/Switch/Switch';
import { Tooltip } from '@mui/material';
import { trackingStore } from '@stores/Tracking';
import { useUIPreferences } from '@stores/UIPreferences';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import css from './AutoplayMomentsSwitch.module.scss';

export const AutoplayMomentsSwitch = observer(() => {
  const uiPreferences = useUIPreferences();

  return (
    <Tooltip title="Play moments automatically" arrow placement="top">
      <div className={classNames(css.autoPlay)}>
        <span className={classNames(css.label)}>Autoplay moments</span>
        <Switch
          checked={uiPreferences.autoplaymoments}
          onChange={() => {
            uiPreferences.toggleAutoplayMoments();
            // Tracks the NEW value after toggle (i.e. what the user switched TO)
            trackingStore.autoplayToggled({
              type: 'moments',
              enabled: uiPreferences.autoplaymoments,
            });
          }}
          isLoading={uiPreferences.isLoading}
        />
      </div>
    </Tooltip>
  );
});
